/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Admin_Tab2Inputs */

const zh_landing_admin_tab2 = /** @type {(inputs: Landing_Admin_Tab2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`智能闪卡`)
};

const en_landing_admin_tab2 = /** @type {(inputs: Landing_Admin_Tab2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smart flashcards`)
};

const es_landing_admin_tab2 = /** @type {(inputs: Landing_Admin_Tab2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarjetas inteligentes`)
};

/**
* | output |
* | --- |
* | "Smart flashcards" |
*
* @param {Landing_Admin_Tab2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const landing_admin_tab2 = /** @type {((inputs?: Landing_Admin_Tab2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Admin_Tab2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_admin_tab2(inputs)
	if (locale === "en") return en_landing_admin_tab2(inputs)
	return es_landing_admin_tab2(inputs)
});